// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"69853959","338":"f6dbe85b","453":"6f10f184","465":"d521c42c","631":"6dbfd387"}[chunkId] + ".chunk.js";
};